import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { CheckoutForm } from "./CheckoutForm";
import { Loader2 } from "lucide-react";
import { useState } from "react";

const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLIC_KEY);

interface StripeCheckoutModalProps {
  open: boolean;
  onClose: () => void;
  amount: number;
  personaId: string;
  clientSecret: string;
}

export function StripeCheckoutModal({
  open,
  onClose,
  amount,
  personaId,
  clientSecret,
}: StripeCheckoutModalProps) {
  const [isLoading, setIsLoading] = useState(true);

  const options = {
    clientSecret,
    appearance: {
      theme: "night",
      variables: {
        colorText: "#ffffff",
        colorTextSecondary: "#ffffff",
        colorTextPlaceholder: "#ffffff80",
      },
      rules: {
        ".Label": {
          color: "#ffffff",
        },
      },
    },
  } as const;

  if (!clientSecret) {
    return null;
  }

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[550px]">
        <DialogHeader>
          <DialogTitle>Purchase Credits</DialogTitle>
          <DialogDescription>
            Purchase {amount * 100} credits for ${amount}
          </DialogDescription>
        </DialogHeader>
        {isLoading && (
          <div className="flex justify-center items-center min-h-[400px]">
            <Loader2 className="h-8 w-8 animate-spin" />
          </div>
        )}
        <div className={isLoading ? "hidden" : ""}>
          <Elements stripe={stripePromise} options={options}>
            <CheckoutForm
              amount={amount}
              personaId={personaId}
              onSuccess={onClose}
              onReady={() => setIsLoading(false)}
            />
          </Elements>
        </div>
      </DialogContent>
    </Dialog>
  );
}
